import { render } from "./CategoryVideos.vue?vue&type=template&id=7cacc827&scoped=true"
import script from "./CategoryVideos.vue?vue&type=script&lang=js"
export * from "./CategoryVideos.vue?vue&type=script&lang=js"

import "./CategoryVideos.vue?vue&type=style&index=0&id=7cacc827&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3966428095/src/eelam-tv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cacc827"]])

export default __exports__